"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var colors_1 = require("../colors");

var themes_1 = require("../themes");

exports.User = function (props) {
  var _a;

  return react_1.default.createElement("svg", {
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48
  }, react_1.default.createElement("defs", null, react_1.default.createElement("path", {
    fill: (_a = colors_1.getColor(props), _a !== null && _a !== void 0 ? _a : themes_1.defaultTheme.colors.default.onColor),
    id: "i-832",
    d: "M23.999,24c4.528,0,10-5.352,10.002-11.998c0-3.076-0.852-5.52-2.529-7.266C29.724,2.922,27.21,2,23.999,2 C17.645,2,14,5.646,14,12C14,18.648,19.47,24,23.999,24z M23.999,4c2.646,0,4.676,0.715,6.03,2.123 c1.308,1.359,1.972,3.338,1.972,5.877c-0.002,5.293-4.477,10-8.002,10S16,17.293,16,12C16,8.352,17.387,4,23.999,4z M33.267,22.037 l-0.562-0.156l-0.413,0.412C30.501,24.084,26.741,26,23.999,26c-2.744,0-6.503-1.916-8.291-3.707l-0.413-0.412l-0.563,0.156 c-4.446,1.244-9.663,5.119-9.73,11.953C4.972,37.025,5.968,44.799,6.01,45.129L6.12,46h35.758l0.111-0.871 c0.043-0.33,1.039-8.104,1.01-11.139C42.929,27.156,37.714,23.281,33.267,22.037z M40.114,44H7.884 C7.62,41.855,6.978,36.332,7,34.01c0.055-5.457,4.087-8.68,7.737-9.885C16.954,26.096,20.833,28,23.999,28 c3.164,0,7.045-1.904,9.264-3.875c3.648,1.205,7.681,4.426,7.736,9.887C41.021,36.332,40.378,41.855,40.114,44z"
  })), react_1.default.createElement("use", {
    x: 0,
    y: 0,
    xlinkHref: "#i-832"
  }));
};